import { styled } from '@mui/material/styles';
import { globalZindex } from 'core/common/constants';
import { Container } from 'core/common/ui/ui-kit';
import { ScreenBackgroundType } from 'core/flow/entities';

export const PageWrapperStyled = styled(Container)`
  z-index: ${globalZindex.content};
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 32px 16px 16px;
  overflow-y: auto;

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    padding-top: 100px;
  }
`;

export const BodyStyled = styled(Container)<{ background?: ScreenBackgroundType }>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  border: 4px dashed green;
  background: ${({ background }) => {
    if (background) {
      return background.backgroundDesktop;
    }
  }};
  ${({ theme }) => theme.breakpoints.up('mobile')} {
    background: ${({ background }) => {
      if (background) {
        return background.backgroundMobile;
      }
    }};
  }
`;
